import { Container, Grid } from '@mui/material'
import { Header } from '../../../components/Header'
import { useLocalState } from '../../../utils/hooks/global/useLocalStorage'
import BotSettingsPanel from '../partners/BotSettingsPanel'

function AdminBotSettings() {
  const [jwt] = useLocalState(null, 'jwt')
  const backendUrl = process.env.REACT_APP_BACKEND_URL

  return (
    <Container maxWidth={'xl'}>
      <Grid container spacing={1}>
        <Grid item xs={12}>
          <Header
            title="Bot Settings"
            subtitle="Manage Telegram contacts message and meeting buttons"
          />
        </Grid>
        <Grid item xs={12}>
          <BotSettingsPanel jwt={jwt} backendUrl={backendUrl} />
        </Grid>
      </Grid>
    </Container>
  )
}

export default AdminBotSettings
